import { useContext } from 'react'
import { CiboUiContext } from '../components/CiboUiProvider'

export const useBuildInfo = () => {
  const { buildInfo } = useContext(CiboUiContext)
  return {
    buildInfo,
  }
}
